import { IonRouterLink } from '@ionic/react';
import { FormattedMessage } from 'react-intl';

import styles from '@components/popovers/Popover.module.css';
import Icon from '@components/text/Icon';
import MiniCopy from '@components/text/MiniCopy';
import { IconName } from '@utils/iconUtils';

type Props = {
  disabled?: boolean;
  icon: IconName;
  iconColor?: 'primary700' | 'success500';
  noBorder?: boolean;
  onClick?: () => void;
  routerLink?: string;
  textKey: string;
};

const PopoverItem = ({
  disabled = false,
  icon,
  iconColor = 'primary700',
  noBorder,
  onClick,
  routerLink,
  textKey
}: Props) => (
  <IonRouterLink
    className={disabled ? styles.disabledItem : ''}
    onClick={disabled ? undefined : onClick}
    routerLink={routerLink}
  >
    <div className={`${styles.popoverItem} ${noBorder ? styles.noBorder : ''}`}>
      <Icon
        ariaLabelKey="accessibility.ariaLabels.download"
        className={`${styles.popoverIcon} ${styles[iconColor]}`}
        icon={icon}
      />
      <MiniCopy color="primary700">
        <FormattedMessage id={textKey} />
      </MiniCopy>
    </div>
  </IonRouterLink>
);

export default PopoverItem;
